import React from 'react';
import { baseVar } from '../../Global/GlobalVariable';

function BlogComp({ data }) {
	return (
		<div className='fade_in_Blog fade_in'>
			<div
				className='row mt-md-5 justify-content-center justify-content-md-start pt-0 mt-2'
				id='blogList w-100'>
				{data?.blog?.map((res, i) => {
					return (
						<div
							key={i}
							className='col-lg-4 col-md-6 col-12 mt-lg-3 mt-2 mb-lg-5 d-flex mt-3'>
							<div className='mx-xl-4  bg-white mb_card_main'>
								<a
									href={baseVar + '/blog/' + res.blog_url}
									title={res.blog_url}>
									<img
										loading='lazy'
										className='mb_card_img'
										src={res.livethumbimageurl}
										width='200'
										height='200'
										alt={res.blogImageAltTag}
										title={res.blogImageTitleTag}
									/>
								</a>
								<a
									href={baseVar + '/blog/' + res.blog_url}
									title={res.blog_url}
									className='text-decoration-none mx-3'>
									<p className='mb_card_mainHead text-start mb-0 mx-3'>
										{res.blog_title}
									</p>
								</a>
								<div className='d-flex justify-content-between mx-3 '>
									<div className='mb_bottom_author text-start '>
										<p className='mb-1'>{res.author}</p>
										<p>Auditor</p>
									</div>
									<div className='text-right  mb_card_date-n-Timeout '>
										<p className='mb-1'>{res.datetime}</p>
										<p>5 Min Read</p>
									</div>
								</div>
							</div>
						</div>
					);
				})}
			</div>
			<a
				href={baseVar + '/blog'}
				title='blog'
				className='text-white text-decoration-none'>
				<button className='choose_service  p-3 px-4 mt-5 mt-lg-4 '>
					Read More Blogs
				</button>
			</a>
		</div>
	);
}

export default BlogComp;
